import { useEffect, useState } from "react";

export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    if (value === "") {
      setDebounced("");
      return undefined;
    }
    if (Object.is(value, debounced)) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay, debounced]);
  return [value === "" ? "" : debounced, value !== "" && !Object.is(value, debounced)];
}
